import "../../../assets/styles/containers/_summaryRatings.scss";
import FlagIcon from "@mui/icons-material/Flag";

const SummaryRating = ({ rating }) => {
  return (
    <div className="summary_rating_block">
      {rating?.map((item) => {
        const color =
          item?.summary?.color ||
          item?.rating?.color ||
          item?.color ||
          item?.Color;
        const name =
          item?.summary?.name ||
          item?.rating?.name ||
          item?.name ||
          item?.Name ||
          item?.title;
        const key =
          item?.summary?.id ||
          item?.rating?.id ||
          item?.id ||
          item?.Id;
        return (
          <div className="summary_rating_container" key={key}>
            <div className="rating_block" style={{ backgroundColor: `${color}` }}>
              {(parseInt(item.include_in_summary)) ? <FlagIcon style={{ color: "#ffffff", fontSize: "10px", position: "relative", top: "-4px", left: "0.5px" }} /> : null}
            </div>
            <div className="summary_rating">{name}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryRating;